import * as firebase from "firebase";
import "firebase/firestore";

let config = {
    apiKey: "AIzaSyC-cI2W0GWqTttw33A-rY3LB4USCGVtsyM",
    authDomain: "loop-gem.firebaseapp.com",
    databaseURL: "https://loop-gem-default-rtdb.firebaseio.com",
    projectId: "loop-gem",
    storageBucket: "loop-gem.appspot.com",
    messagingSenderId: "614231609666",
    appId: "1:614231609666:web:95a55169f3eb0b65a6b8db",
    measurementId: "G-VVJ8Q2MBNT"
};

firebase.initializeApp(config);

export default firebase;